import * as Sentry from '@sentry/react'

interface ApiErrorContext {
  endpoint: string
  status?: number
  [key: string]: unknown
}

// Only 5xx (server-side) and network-level failures (no response at all —
// offline, DNS, CORS, connection refused) are real bugs worth paging on.
// 4xx are expected, already-handled UI states (validation, not found) and
// would just be noise if sent to Sentry.
export function reportApiError(error: unknown, context: ApiErrorContext): void {
  if (context.status !== undefined && context.status < 500) return
  Sentry.captureException(error, { extra: context })
}
